import { post, get, postJson } from '../request';
import { postUrls, getUrls, postJsons } from './apilist';

let apis = {};
for (let url in postUrls) {
  let isCatch = false;
  let U = postUrls[url];
  if (typeof postUrls[url] === 'object') {
    isCatch = postUrls[url].catch || false;
    U = postUrls[url].url;
  }
  apis[url] = function (params, server = '') {
    return post(server + U, params, isCatch);
  };
}

for (let url in getUrls) {
  let isCatch = false;
  let U = getUrls[url];
  if (typeof getUrls[url] === 'object') {
    isCatch = getUrls[url].catch || false;
    U = getUrls[url].url;
  }
  apis[url] = function (params, server = '') {
    return get(server + U, params, isCatch);
  };
}

for (let url in postJsons) {
  let isCatch = false;
  let U = postJsons[url];
  if (typeof postJsons[url] === 'object') {
    isCatch = postJsons[url].catch || false;
    U = postJsons[url].url;
  }
  apis[url] = function (params, server = '') {
    return postJson(server + U, params, isCatch);
  };
}

export default apis;
